import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactInfoSection = () => {
  const contactMethods = [
    {
      icon: 'Mail',
      label: 'E-Mail Support',
      value: 'oliver.wagner@gridbalance.de',
      action: 'mailto:oliver.wagner@gridbalance.de',
      description: 'Antwort innerhalb von 24 Stunden'
    },
    {
      icon: 'Phone',
      label: 'Telefon-Hotline',
      value: '+49 (0) 152 231 524 76',
      action: 'tel:+4915223152476',
      description: 'Mo-Fr: 9:00 - 17:00 Uhr'
    },
    {
      icon: 'MessageCircle',
      label: 'Live-Chat',
      value: 'Chat starten',
      action: '#',
      description: 'Sofortige Unterstützung'
    }
  ];

  return (
    <div className="bg-card rounded-xl shadow-lg p-6 md:p-8 mb-8 border border-border">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-secondary/10 rounded-full flex items-center justify-center">
          <Icon name="Headphones" size={24} color="var(--color-secondary)" />
        </div>
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground">
          Haben Sie Fragen?
        </h2>
      </div>

      <p className="text-muted-foreground mb-6">
        Unser Support-Team steht Ihnen jederzeit zur Verfügung. Kontaktieren Sie uns über einen der folgenden Kanäle:
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {contactMethods?.map((method) => (
          <a
            key={method?.label}
            href={method?.action}
            className="bg-muted/50 rounded-lg p-4 hover:bg-muted transition-smooth border border-transparent hover:border-primary/20 group"
          >
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-3 group-hover:bg-secondary/20 transition-smooth">
                <Icon name={method?.icon} size={24} color="var(--color-secondary)" />
              </div>
              <h3 className="font-semibold text-foreground text-sm mb-1">
                {method?.label}
              </h3>
              <p className="text-sm font-medium text-secondary mb-1">
                {method?.value}
              </p>
              <p className="text-xs text-muted-foreground">
                {method?.description}
              </p>
            </div>
          </a>
        ))}
      </div>

      {/* Dealership Partnership Notice */}
      <div className="bg-gradient-to-r from-secondary/10 to-primary/10 rounded-lg p-4 border border-secondary/20">
        <div className="flex items-start gap-3">
          <Icon name="Handshake" size={20} color="var(--color-secondary)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-semibold text-foreground mb-1">
              In Partnerschaft mit Ihrem Partner
            </p>
            <p className="text-xs text-muted-foreground">
              Grid Balance arbeitet eng mit Ihrem Partner zusammen, um Ihnen den bestmöglichen Service zu bieten.
              Ihr Wertgutschein kann direkt bei Ihrem Partner eingelöst werden.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfoSection;